module.exports = __webpack_public_path__ + "img/sofrigam-logo-meta.2cb9909f.jpg";